import {connect} from "react-redux";
import RaiseIssue from "./RaiseIssue";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../../service/Lead/action";
import { selfRatingDetails, ratingSave } from "../../../../service/Dealer/action";
import { documentUploadUrlPublic } from "../../../../service/fileUpload/action";
import { saveTicketDetails } from "../../../../service/RaiseTicket/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
    selfListing:state.Dealer.selfListing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getLead,
            getLeadFilter,
            selfRatingDetails,
            saveTicketDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RaiseIssue);
